<template>
    <div id="downloadcontent">
        <form>
            <div class="cm-customercenter-download-container">
                <div class="row p-3 my-3 cm-customercenter-download-row" v-for="item in documents" :key="item.id">
                    <div class="col-10 pl-0">
                        <ul class="p-0">
                            <li>
                                <h4>{{$t(item.documentTitle)}}</h4>
                            </li>
                            <li v-html="$t(item.documentContent)"></li>
                        </ul>
                    </div>
                    <div class="col-2 d-flex justify-content-center align-items-center">
                        <a :href="item.link" target="_blank" class="cm-customercenter-download-btn">
                            {{item.documentFileType}}
                            <br>
                            {{$t('download.Download')}}
                        </a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import store from '@/store/store-controller/store.js'
import eventBus from '@/assets/js/event/EventBus.js'

    export default {
        name: 'downloadcontent',
        data() {
            return {
                documents: []
            }
        },
        mounted() {
            // 更換語言時
            const self = this;
            eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_DOWNLOAD_CONTENT, function(i18n) {
                self.getproduct(i18n.locale);
            })
        },
        methods: {
            getproduct(language) {
                var now_lang = language;
                var link = "/main/frontend/pdf/applyForCustomerService_en.pdf";
                
                if(now_lang.toLowerCase()=="zh-tw" || now_lang.toLowerCase()=="zh-cn") {
                    link = "/main/frontend/pdf/applyForCustomerService.pdf";
                }
                this.documents = [{
                        "documentTitle": 'download.Document.accountService',
                        "documentContent": 'download.Document.downloadNotice',
                        "documentFileType": "pdf",
                        "link": process.env.VUE_APP_URL_DOMAIN_LOGIN + link
                    }
                ]
            }
        },
        created() {
            this.getproduct(store.getters['storeI18n/getNowLanguage']);
        }
    }
</script>